import React from 'react';

import type { Props } from '../types/PageSegmentLoadMarkProps.ts';

import { UFOSegmentLoadMark } from './UFOSegmentLoadMark.tsx';

/**
 * Component that records a UFO custom mark for a page segment load.
 */
export const PageSegmentLoadMark = (props: Props) => {
	return <UFOSegmentLoadMark {...props} />;
};
